<div class="backdrop-spinner"></div>
<div class="spinner-container d-flex align-items-center justify-content-center" [style.width.px]="diameter" [style.height.px]="diameter">
  <mat-spinner [diameter]="diameter"></mat-spinner>
</div>
